import { Rokojori } from "../../_rokojori.com/js/Rokojori";
import { MessageWriter } from "../messages/MessageWriter";
import { DomainValidator } from "./DomainValidator";
import { Validator } from "./Validator";

export class EmailValidator extends Validator
{
  static isValid( value:string )
  {
    return new EmailValidator().validate( value );
  }

  validate( value:string )
  {
    let valueLength = value.length;

    let atPosition = value.indexOf( "@" );

    if ( atPosition === -1 )
    {
      this.error( Rokojori.locale( { en:"Missing @-sign", de:"Fehlendes @-Zeichen" } ) );
      return false;
    }

    let localPart = value.substring( 0, atPosition );
    
    if ( ! this.validateLocalPart( localPart ) )
    {
      this.error( Rokojori.locale( { en:"Invalid local part", de:"Ungültiger Lokal-Teil" } ) );
      return false;
    }   

    let domain = value.substring( atPosition + 1, valueLength );

    let domainValidator = new DomainValidator();

    if ( ! domainValidator.validate( domain ) )
    {
      this.error( Rokojori.locale( { en:"Invalid domain", de:"Ungültige Domain" } ) );
      return false;
    }
    
    return true;
  }


  validateLocalPart( localPart:string )
  {
    let localPartLength = localPart.length;
    let quoted = false;

    if ( localPartLength > 64 )
    {
      return false;
    }

    if ( localPart.startsWith( '"' ) && localPart.endsWith( '"' ) )
    { 
      localPart = localPart.substr( 1, localPartLength - 2 );
      quoted = true;
    }

    if ( localPart.indexOf( '..' ) !== -1 )
    {
      return false;
    }

    let regex = /^[a-zA-Z0-9-_!#$%&\'*+\.\/=?^_`{|}~]+$/;
    let isOnlyAllowedCharacters = regex.test( localPart );

    if ( isOnlyAllowedCharacters )
    {
      return true;
    }

    if ( ! quoted )
    {
      return false;
    }

    regex = /^[a-zA-Z0-9-_!#$%&\'*+\/=?^_`{|}~(),:;<>@[\]]+$/;
    let isOnlyAllowedQuotedCharacters = regex.test( localPart );
    
    if ( isOnlyAllowedQuotedCharacters )
    {
      return true;
    }

    regex = /^[a-zA-Z0-9-_!#$%&\'*+\/=?^_`{|}~(),:;\\<>@[\]"]+$/;

    let isWithEscapingCharacters = regex.test( localPart );

    if ( ! isWithEscapingCharacters ) 
    {
      return false;
    }
    
    
    let unescapedSlashRegex = /[^\\]\\/;
    
    if ( unescapedSlashRegex.test( localPart ) )
    {
      return false;
    }

    let unescapedQuotesRegex = /[^\\]"/;
    
    if ( unescapedQuotesRegex.test( localPart ) )
    {
      return false;
    }    

    return true;
  }
  
}
